<template>
    <div class="d-flex flex-column px-1">
        <div class="naturalRidingTitle mt-3">Monta Natural</div>

        <div class="d-flex flex-column">
       <validation-observer ref="registerForm">
                <b-form class="mt-2" @submit.prevent="validationForm">
                    <b-form-group label="Fecha" label-for="datepicker" class="">
                        <b-form-datepicker id="fecha_compra" name="fecha_compra" v-model="reproductive.date" 
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        :min="minCfgDate" :max="maxCfgDate"
                        locale="es-ES"/>   
                        
                    </b-form-group>
                    <b-form-group label="Toro" label-for="bull"  class="mt-1" >

                        <v-select  id="bull" v-model="animal_picker_male" :options="animalsOptionsMal" :values="animalsOptionsMal.value"  label="text" />
                    </b-form-group>
                    <b-form-group label="Filtro de seleccion de vacas" label-for="cowSelection"  class="" >

                        <v-select  id="cowSelection" v-model="animal_picker_female" :options="animalsOptionsFem" :values="animalsOptionsFem.value" label="text"  />
                    </b-form-group>
                </b-form>
            </validation-observer>
            <div >
                <b-form-group  label="Observaciones" label-for="Exam">
                    <validation-provider #default="{ errors }" name="Exam" vid="Exam" rules="required|Exam">
                        <b-form-textarea  id="Exam" v-model="reproductive.details"  rows="5"
                            max-rows="6"></b-form-textarea>

                    </validation-provider>
                </b-form-group>
            <b-button
                type="submit" v-on:click="insertReproductive"
                class="bg-primary dataButton mt-3 d-flex align-items-center justify-content-center ml-3"   
            
              >
               <div class="ml-5"> Incluir Evento </div> <div class="pl-3" style="color:#D7B92C"> <feather-icon icon="PlusIcon"  size="18" /></div>
              </b-button>
        </div></div>
        <ControlMenu />
    </div>
</template>



<script>
import ControlMenu from '@/components/ControlMenu.vue'
import vSelect from 'vue-select'
import "vue-select/dist/vue-select.css";
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BFormGroup, BFormInput, BFormDatepicker, BForm, BImg, BButton, BFormTextarea } from 'bootstrap-vue'
import { required } from '@validations'
import flatPickr from 'vue-flatpickr-component'
let self= this;

export default {
    components: {
        ControlMenu,
        flatPickr,
        BFormGroup,
        BFormDatepicker,
        ValidationProvider,
        ValidationObserver,
        BFormGroup,
        BFormInput,
        BForm,
        required,
        vSelect,
        BImg,
        BButton,
        BFormTextarea,
    },
    data() {
        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        // 15th two months prior
        const minDate = new Date(today)
        minDate.setMonth(minDate.getMonth() - 119)
        minDate.setDate(15)
        // 15th in two months
        const maxDate = new Date(today)
        maxDate.setMonth
        maxDate.setMonth(maxDate.getMonth())
        maxDate.setDate(maxDate.getDate())
        return {
            date: null,
            maxCfgDate:maxDate,
            minCfgDate:minDate,
            setLang:'es',
            animal_picker_male: null,
            animal_picker_female: null,
            animalsOptionsMal:[],
            animalsOptionsFem:[],
            reproductive:{
                farm_id: localStorage.getItem('currentFarm'),
                status:1,
                date:today,
                condition_id:1,
                type:9,
                animal_id:0,
                days:0,
                male_id:0,
                details:'',
            }
        }
    },
    methods:{
        async fetchAnimalsFem(config){
            let farmId= localStorage.getItem('currentFarm');
            fetch(this.$apiUrl+"list/animals?farm_id="+farmId+"&sex=1&state=1", config)
            .then(response => response.json())
            .then(result => {
                console.log(result.animals);
                this.animalsOptionsFem = result.animals.map(item => {return {value:item.id,text:item.number+ ' '+item.name}})
            })
        },

        async fetchAnimalsMal(config){
            let farmId= localStorage.getItem('currentFarm');
            fetch(this.$apiUrl+"list/animals?farm_id="+farmId+"&sex=0", config)
            .then(response => response.json())
            .then(result => {
                console.log(result.animals);
                this.animalsOptionsMal = result.animals.map(item => {return {value:item.id,text:item.number+ ' '+item.name}})
            })
        },

        insertReproductive(){
            this.reproductive.animal_id=this.animal_picker_female.value;
            this.reproductive.male_id=this.animal_picker_male.value;
            console.log(this.reproductive);
            const token = localStorage.getItem("accessToken");
            const config = {headers: {"X-Authorization": `Bearer ${token}`}};
            this.$http.post("add/reproductive_records", this.reproductive, config).then(() => {
                this.reproductive={
                    status:1,
                    date:null,
                    condition_id:1,
                    type:9,
                    animal_id:0,
                    days:0,
                    male_id:0,
                    details:'',
                }
            
                this.$swal({
                    title: 'Registro reproductivo',
                    text: 'Se insertó registro de monta natural de manera satisfactoria',
                    type: 'success',
                    icon:'success',
                    showCancelButton: false,
                    confirmButtonColor:'#5E8F23',
                    showCloseButton: true,
                    showLoaderOnConfirm: false  
                }).then(function(){
                    history.back();
                });
            }).catch(error => {
                console.log(error)
            });
        }
    },
    created() {
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.fetchAnimalsFem(config);
        this.fetchAnimalsMal(config);
    }
}
</script>
    

<style lang="scss">
.naturalRidingTitle {

    font-weight: 600;
    font-size: 24px;

}

.datePicker {
    background: #FFFFFF;
    border-radius: 5px;
}

.additive {
    font-weight: 400;
    font-size: 12px;
    color: #6E6B7B;
}
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/pages/page-auth.scss';
</style>